let CourseGroupSelectionView = Backbone.View.extend
(
    {
        template: _.template($('#course-groups-selection-template').html()),

        render: function () {
            this.$el.html(this.template(this.model.attributes));
            return this;
        }
    }
);
